import React, { useState } from "react";
import "./AICourse.css";
import { Link } from "react-router-dom";
import axios from "axios";
import { API_URL } from "../config/api";

import {
  FaProjectDiagram,
  FaLaptopCode,
  FaUserTie,
  FaBriefcase,
  FaChartLine,
  FaCertificate,
  FaCheckCircle,
} from "react-icons/fa";

const AICourse = () => {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    mode: "",
    level: "",
  });

  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;

    let updatedValue = value;

    if (name === "name") {
      updatedValue = value.replace(/[^A-Za-z\s]/g, "");
    }

    if (name === "email") {
      updatedValue = value.toLowerCase();
    }

    if (name === "phone") {
      updatedValue = value.replace(/\D/g, "").slice(0, 10);
    }

    setFormData({
      ...formData,
      [name]: updatedValue,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setLoading(true);
    setMessage("");
    setError("");

    if (
      !formData.name ||
      !formData.phone ||
      !formData.email ||
      !formData.mode ||
      !formData.level
    ) {
      setError("Please fill all fields");
      setLoading(false);
      return;
    }

    if (!/^\d{10}$/.test(formData.phone)) {
      setError("Phone number must be exactly 10 digits");
      setLoading(false);
      return;
    }

    if (!/^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/.test(formData.email)) {
      setError("Enter a valid email address");
      setLoading(false);
      return;
    }

    try {
      const payload = {
        ...formData,
        courseName: "Artificial Intelligence",
      };

      const res = await axios.post(API_URL, payload);

      console.log("RESPONSE:", res.data);

      if (res.data.success) {
        window.open(res.data.whatsappUrl, "_blank");

        setMessage("Redirecting to WhatsApp...");

        setTimeout(() => {
          setMessage("");
        }, 3000);

        setFormData({
          name: "",
          phone: "",
          email: "",
          mode: "",
          level: "",
        });
      }
    } catch (err) {
      console.error("ERROR:", err);

      setError(
        err.response?.data?.message ||
          "Something went wrong. Please try again.",
      );
    }

    setLoading(false);
  };

  return (
    <div className="ai-hero">
      {message && <div className="success-msg">{message}</div>}
      {error && <div className="error-msg">{error}</div>}

      <div className="breadcrumb">
        <Link to="/">Home</Link> / <span>AICourse</span>
      </div>

      <div className="overlay">
        <div className="hero-left">
          <span className="badge">AAPS Career</span>

          <h1>
            <span className="white">Artificial </span>
            <span className="orange">Intelligence</span>
            <span className="white"> Course</span>
          </h1>

          <div className="desc">
            <ul>
              <li>
                <FaCheckCircle /> Strong foundation in Artificial Intelligence
              </li>
              <li>
                <FaCheckCircle /> Learn ML, DL, NLP & Computer Vision
              </li>
              <li>
                <FaCheckCircle /> Real-time projects for practical exposure
              </li>
              <li>
                <FaCheckCircle /> Hands-on training with expert trainers
              </li>
              <li>
                <FaCheckCircle /> Solve real-world problems using AI
              </li>
              <li>
                <FaCheckCircle /> Prepare for high-demand AI jobs
              </li>
            </ul>
          </div>

          <div className="features">
            <div>
              <FaProjectDiagram /> Live Projects
            </div>
            <div>
              <FaLaptopCode /> Hands-on Experience
            </div>
            <div>
              <FaUserTie /> Expert Trainers
            </div>
            <div>
              <FaBriefcase /> Placement Support
            </div>
            <div>
              <FaChartLine /> Career Growth
            </div>
            <div>
              <FaCertificate /> Certification
            </div>
          </div>
        </div>

        <div className="hero-right">
          <div className="form-card">
            <h3>Fill Your Details</h3>

            <form onSubmit={handleSubmit}>
              <input
                type="text"
                name="name"
                placeholder="Full Name"
                value={formData.name}
                onChange={handleChange}
                autoComplete="off"
                required
              />

              <input
                type="text"
                name="phone"
                placeholder="Phone Number"
                value={formData.phone}
                onChange={handleChange}
                maxLength={10}
                autoComplete="off"
                required
              />

              <input
                type="email"
                name="email"
                placeholder="Email Address"
                value={formData.email}
                onChange={handleChange}
                autoComplete="off"
                required
              />

              <select
                name="mode"
                value={formData.mode}
                onChange={handleChange}
                required
              >
                <option value="">Select Training Type</option>
                <option value="Online">Online</option>
                <option value="Classroom">Classroom</option>
              </select>

              <select
                name="level"
                value={formData.level}
                onChange={handleChange}
                required
              >
                <option value="">I am...</option>
                <option value="Beginner">Beginner</option>
                <option value="Student">Student</option>
                <option value="Working Professional">
                  Working Professional
                </option>
              </select>

              <button type="submit" className="book-btn" disabled={loading}>
                {loading ? "Submitting..." : "Book Now"}
              </button>
            </form>

            <div className="divider">OR</div>

            <a href="tel:+919573470659" className="call-btn">
              Call Now
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AICourse;
